import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { apiGetEngagements, apiUpdateEngagement } from "../../../api/ApiEngagement";
import { useTranslation } from "react-i18next";
import { apiUpdateOrgunit } from "../../../api/ApiOrgunit";

const ModalChoixEngagements = (props) => {
  const { t } = useTranslation();
  const { idOrgUnit, orgunitName, ReduxInstanceId, show, handleClose } = props;
  const [engagements, setEngagements] = useState([]);

  const recupDatas = async () => {
    const res = await apiGetEngagements(ReduxInstanceId);
    setEngagements(res.data);
  };

  const addRemoveEngagement = async (idEngagement) => {
    const engagementsCopy = [...engagements];
    const index = engagementsCopy.findIndex((item) => item._id === idEngagement);
    if (engagementsCopy[index].orgUnits.includes(idOrgUnit)) {
      engagementsCopy[index].orgUnits = engagementsCopy[index].orgUnits.filter(
        (item) => item !== idOrgUnit
      );
    } else {
      engagementsCopy[index].orgUnits.push(idOrgUnit);
    }

    const formData = new FormData();
    engagementsCopy[index].orgUnits.forEach((element) => {
      formData.append("orgUnits[]", element);
    });
    await apiUpdateEngagement(engagementsCopy[index]._id, formData);
    // mise a jour à blanc d'un orgunit pour changer la date d'update du orgUnit pour en suite s'en servir pour calcul sur table SOUS MISSIONS (revient presque à une commande TOUCH sur linux )
    await apiUpdateOrgunit(idOrgUnit);
    // fin mise a jour à blanc d'un orgunit pour changer la date d'update du orgUnit pour en suite s'en servir pour calcul sur table SOUS MISSIONS  (revient presque à une commande TOUCH sur linux )
    setEngagements(engagementsCopy);
  };

  useEffect(() => {
    if (show) {
      recupDatas();
    }
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("admin.PageAdminOrgunits.modalChoixEngagementsTitre")} "{orgunitName}"
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {engagements.map((engagement) => (
          <Form.Check
            key={engagement._id}
            id={"engagement_" + engagement._id}
            type="switch"
            label={engagement.nom}
            value={engagement._id}
            onChange={(e) => {
              addRemoveEngagement(e.target.value);
            }}
            checked={engagement.orgUnits.includes(idOrgUnit) ? "checked" : ""}
          />
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default ModalChoixEngagements;
